module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h6', [_vm._v("待補充清單")]), _vm._v(" "), _c('vuetable', {
    ref: "vuetable",
    attrs: {
      "api-url": (_vm.server + "/api/drug-storage-not-full/"),
      "data-path": "",
      "pagination-path": "",
      "fields": _vm.fields,
      "api-mode": true,
      "css": _vm.boostrapCss,
      "http-options": _vm.httpOptions
    },
    on: {
      "vuetable:cell-clicked": _vm.onCellClicked
    },
    scopedSlots: _vm._u([{
      key: "num-refill",
      fn: function(props) {
        return [_c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v(_vm._s(props.rowData.max_stock - props.rowData.stock))])]
      }
    }])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.setRefill
    }
  }, [_vm._v("設定補藥項目")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e01b9ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/TagManagement/Planning.vue
// module id = 1504
// module chunks = 1